<template>
  <div class="freight-select">
    <el-select
      :value="value"
      filterable
      remote
      clearable
      :remote-method="search"
      :loading="loading"
      placeholder="搜索并选择运费模板"
      @input="$emit('input', $event)"
    >
      <el-option
        v-for="t in options"
        :key="t.id"
        :value="t.id"
        :label="t.name"
      />
    </el-select>
    <el-button type="text" icon="el-icon-plus" @click="creating = true"
      >新建模板</el-button
    >
    <el-dialog
      title="新建运费模板"
      :visible.sync="creating"
      width="min(1100px, calc(100vw - 32px))"
      append-to-body
      :close-on-click-modal="false"
      :before-close="close"
      destroy-on-close
    >
      <freight-editor
        v-if="creating"
        ref="editor"
        @saved="saved"
        @cancel="creating = false"
      />
    </el-dialog>
  </div>
</template>
<script>
import FreightEditor from "./FreightEditor.vue";
import { freightList, freightDetail } from "@/api/freight";
export default {
  components: { FreightEditor },
  props: { value: { default: null } },
  data() {
    return {
      options: [],
      selectedOption: null,
      loading: false,
      creating: false,
      requestId: 0
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(id) {
        if (id) this.loadSelected(id);
      }
    }
  },
  created() {
    this.search("");
  },
  methods: {
    async search(keyword) {
      const request = ++this.requestId;
      this.loading = true;
      try {
        const r = await freightList({ keyword, page: 1, pageSize: 50 });
        if (r.bizcode === 100 && request === this.requestId) {
          this.options = r.data.entitys;
          this.keepSelected();
        }
      } catch (_) {
        /* 请求层显示异常，不清空原有选择和商品表单。 */
      } finally {
        if (request === this.requestId) this.loading = false;
      }
    },
    keepSelected() {
      if (
        this.selectedOption &&
        !this.options.some(t => t.id === this.selectedOption.id)
      )
        this.options.unshift(this.selectedOption);
    },
    async loadSelected(id) {
      try {
        const r = await freightDetail(id);
        if (r.bizcode === 100 && this.value === id) {
          this.selectedOption = r.data;
          this.keepSelected();
        }
      } catch (_) {
        /* 无效模板交由保存时明确校验。 */
      }
    },
    saved(template) {
      this.selectedOption = template;
      this.keepSelected();
      this.$emit("input", template.id);
      this.creating = false;
    },
    async close(done) {
      if (await this.confirmLeave()) done();
    },
    async confirmLeave() {
      return !this.creating || (await this.$refs.editor.confirmLeave());
    }
  }
};
</script>
<style scoped>
.freight-select {
  display: flex;
  align-items: center;
  gap: 14px;
}
.freight-select > .el-select {
  flex: 1;
  min-width: 160px;
}
.freight-select > .el-button {
  margin-left: 0;
}
</style>
